import useMarket from "./useMarket";
export default () => {
    const { currentMarket, loading, error } = useMarket();
    if (error) {
        console.error(error);
        return null;
    }
    if (loading) {
        return null;
    }
    return currentMarket;
};
